import { Empty, EmptyProps } from '@ps/ds/components/blocks/Empty/Empty'

import unhappyBug from '../../../assets/illustrations/il-empty-bug-unhappy.svg?inline'

interface ErrorStateProps extends Omit<EmptyProps, 'description'> {
  description?: string
  /** To be used with the default retry button (secondaryAction) */
  retryOnClick?: () => void
  retryLabel?: string
}

const DEFAULT_TITLE = 'Oops! We hit a snag!'
const DEFAULT_DESCRIPTION = 'Even the best traps need a reset sometimes...please try again!'
const DEFAULT_IMAGE = <img src={unhappyBug} alt="" aria-hidden="true" />

export const ErrorState = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  primaryAction,
  secondaryAction,
  linkAction,
  retryOnClick,
  retryLabel = 'Retry',
  ...rest
}: ErrorStateProps) => {
  const retryButton = retryOnClick
    ? {
        label: retryLabel,
        onClick: retryOnClick,
      }
    : undefined

  return (
    <Empty
      title={title}
      description={description}
      image={image}
      linkAction={linkAction}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction || retryButton}
      {...rest}
    />
  )
}
